module.exports = __webpack_public_path__ + "img/banner-gif.15244d4b.gif";